import Battery0Bar from '@mui/icons-material/Battery0Bar'
import Battery1Bar from '@mui/icons-material/Battery1Bar'
import Battery2Bar from '@mui/icons-material/Battery2Bar'
import Battery3Bar from '@mui/icons-material/Battery3Bar'
import Battery4Bar from '@mui/icons-material/Battery4Bar'
import Battery5Bar from '@mui/icons-material/Battery5Bar'
import Battery6Bar from '@mui/icons-material/Battery6Bar'
import BatteryFull from '@mui/icons-material/BatteryFull'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTemplateNodeSoftLimit } from 'src/features/templateEdit/useTemplateNodeSoftLimit'

// 残量の少ない順。バッテリーの目盛りは「あとどれだけ追加できるか」を表す
const BATTERY_ICONS = [
  Battery0Bar,
  Battery1Bar,
  Battery2Bar,
  Battery3Bar,
  Battery4Bar,
  Battery5Bar,
  Battery6Bar,
  BatteryFull,
] as const

/**
 * ひな形全体の「使用中の容量 / 上限」の表示。ひな形詳細の末尾に置く。
 */
export const TemplateNodeCount = () => {
  const { count, limit, isOverLimit, isReady } = useTemplateNodeSoftLimit()
  if (!isReady) {
    return null
  }

  const remainingRatio = Math.max(1 - count / limit, 0)
  const BatteryIcon =
    BATTERY_ICONS[Math.round(remainingRatio * (BATTERY_ICONS.length - 1))] ??
    Battery0Bar

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <BatteryIcon fontSize="small" color={isOverLimit ? 'error' : 'action'} />
      <Typography
        variant="body2"
        color={isOverLimit ? 'error' : 'text.secondary'}
      >
        容量 {count.toLocaleString()}/{limit.toLocaleString()} 使用中
      </Typography>
    </Stack>
  )
}
